export default () => {
	throw new Error('no module');
};
